import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/checkout-images/icono-como-llegar-rojo.webp")